var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.5C0 4.53986 4.03986 0.5 9 0.5C13.9601 0.5 18 4.53986 18 9.5C18 14.4601 13.9601 18.5 9 18.5C4.03986 18.5 0 14.4601 0 9.5ZM0.779896 9.5C0.779896 14.0312 4.4688 17.7201 9 17.7201C13.5312 17.7201 17.2201 14.0312 17.2201 9.5C17.2201 4.9688 13.5312 1.2799 9 1.2799C4.4688 1.2799 0.779896 4.9688 0.779896 9.5Z",
    fill: "#4E5972"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21739 8.04348C8.21739 7.76734 8.44125 7.54348 8.71739 7.54348H9.28261C9.55875 7.54348 9.78261 7.76734 9.78261 8.04348V13.7113C9.78261 13.9874 9.55875 14.2113 9.28261 14.2113H8.71739C8.44125 14.2113 8.21739 13.9874 8.21739 13.7113V8.04348Z",
    fill: "#4E5972"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21739 5.16304C8.21739 4.74883 8.55318 4.41304 8.96739 4.41304H9.03261C9.44682 4.41304 9.78261 4.74883 9.78261 5.16304V5.47087C9.78261 5.88508 9.44682 6.22087 9.03261 6.22087H8.96739C8.55318 6.22087 8.21739 5.88508 8.21739 5.47087V5.16304Z",
    fill: "#4E5972"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f05aca4c0f4ed26acb83d6db1d21d97f.svg";
export { ForwardRef as ReactComponent };